/**
 * Full addresses for a Speedy's images and preview clip. `speedy_cards` (and the series and search
 * reads built on it) return bare R2 paths (`/system/<media_id>/poster_12s.jpg`, `/previews/…`), like
 * every media row; on a page they must go through resolveMediaUrl (VITE_MEDIA_HOST), or the browser
 * asks the app's own site for them and gets nothing (dev, 3 Nov). Use these wherever one is shown.
 */
import { resolveMediaUrl } from '@/lib/media';

interface HasSpeedyMedia {
  poster_url?: string | null;
  small_poster_url?: string | null;
  preview_clip_url?: string | null;
}

/** The small poster when there is one (tiles, cards), else the full one. */
export function speedyPosterSrc(c: HasSpeedyMedia | null | undefined): string | undefined {
  return resolveMediaUrl(c?.small_poster_url ?? c?.poster_url);
}

/** The silent preview clip. */
export function speedyClipSrc(c: HasSpeedyMedia | null | undefined): string | undefined {
  return resolveMediaUrl(c?.preview_clip_url);
}
